import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <header className="site-header">
      <div className="navbar-container">
        <Link to="/" className="logo" onClick={closeMenu}>
          <img src="/assets/logo.png" alt="AITher Enterprise" className="logo-img" />
        </Link>

        <nav className={`nav-menu ${isOpen ? 'active' : ''}`}>
          <Link to="/" className="nav-link" onClick={closeMenu}>
            Inicio
          </Link>
          <Link to="/servicios" className="nav-link" onClick={closeMenu}>
            Servicios
          </Link>
          <Link to="/quienes" className="nav-link" onClick={closeMenu}>
            Quiénes Somos
          </Link>
          <Link to="/contacto" className="nav-link" onClick={closeMenu}>
            Contacto
          </Link>
        </nav>

        <button 
          className="hamburger" 
          onClick={toggleMenu}
          aria-label="Toggle navigation"
          aria-expanded={isOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
};

export default Navbar;
